import { AfterViewInit, Component, ElementRef, OnInit } from '@angular/core';
import { Observable, timer } from 'rxjs';
import { UserNotification } from 'projects/app-misc/src/app/modules/notification/data/user-notification';
import { NotificationService } from 'projects/app-misc/src/app/modules/notification/data/notification.service';
import { environment } from 'projects/desktop/src/environments/environment';
import { map } from 'rxjs/operators';
import * as moment from 'moment/moment';
import { MentionsQuery } from 'projects/app-misc/src/app/modules/notification/data/mentions.query';

@Component({
  selector: 'app-mention-page',
  templateUrl: './mention-page.component.html',
  styleUrls: ['./mention-page.component.scss']
})
export class MentionPageComponent implements OnInit, AfterViewInit {
  start = 0;
  limit = 12;

  totalElements$ = this.mentionsQuery.total;
  mentionMap$: Observable<Map<string, UserNotification[]>>;

  constructor(
    protected el: ElementRef,
    protected notificationService: NotificationService,
    protected mentionsQuery: MentionsQuery
  ) {
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    timer(1).subscribe(emit => {
      this.limit = Math.trunc((this.el.nativeElement.offsetHeight - environment.bottomOfSet) / 80);

      this.mentionMap$ = this.mentionsQuery
      .selectAll()
      .pipe(
        map(notifications => {
          const notificationMap = new Map<string, UserNotification[]>()
          notifications.forEach(usernotification => {
            const key = moment(usernotification.notification.createdTime).format('L')
            if(!notificationMap.has(key)) {
              notificationMap.set(key, [])
            }
            notificationMap.get(key).push(usernotification)
          })

          return notificationMap
        })
      )

      this.loadNotifications(this.start, this.limit)

    })
  }

  returnZero() {
    return 0
  }

  loadNotifications(start: number, limit: number) {
    this.notificationService.loadMentions(start, limit)
  }

  // FIXME: use type
  onPageChange(event) {
    this.loadNotifications(event.page, event.rows)
  }

}
